import { useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useTranslation } from '../../contexts/LanguageContext'
import { AuthModal } from '../auth/AuthModal'
import { UserMenu } from '../auth/UserMenu'
import { UndoRedoButtons } from '../editor/UndoRedoButtons'
import { LanguageSwitcher } from './LanguageSwitcher'

export function Header() {
  const { user, loading } = useAuth()
  const { t } = useTranslation()
  const [showAuthModal, setShowAuthModal] = useState(false)
  const [authModalView, setAuthModalView] = useState<'login' | 'register'>('login')

  const openLogin = () => {
    setAuthModalView('login')
    setShowAuthModal(true)
  }

  return (
    <>
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-full mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-14">
            {/* Logo */}
            <a href="/" className="flex items-center gap-2">
              <img src="/images/logo.png" alt="CVtoday" className="w-8 h-8" />
              <span className="font-display font-bold text-lg text-gray-900">
                CVtoday
              </span>
            </a>

            {/* Center - Undo/Redo (desktop only) */}
            <div className="hidden lg:flex items-center">
              <UndoRedoButtons />
            </div>

            {/* Right side */}
            <div className="flex items-center gap-3">
              <LanguageSwitcher />
              {!loading && (
                <>
                  {user ? (
                    <UserMenu />
                  ) : (
                    <button
                      onClick={openLogin}
                      className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 hover:text-primary transition-colors"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                      {t.header.login}
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </header>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        initialView={authModalView}
      />
    </>
  )
}
